import { IShipmentDataWithoutShipments } from 'types/orders';

/**
 * Construye el texto con toda la información del envío para copiar al portapapeles.
 * Incluye empleado, ID, código postal, teléfono, ciudad, indicaciones y dirección.
 * @param shipment - Datos del envío (con o sin array de shipments)
 * @returns Texto formateado, una línea por campo, unido por saltos de línea
 */
export const getShipmentInfoCopyText = (
  shipment: IShipmentDataWithoutShipments
): string => {
  const {
    receiverName,
    receiverInfo,
    receiverIdDocument,
    zipCode,
    receiverPhone,
    city,
    additionalReferences,
    deliveryAddress,
    userInfo
  } = shipment ?? {};

  const fullName =
    receiverName ||
    receiverInfo?.receiverName ||
    (userInfo?.firstName && userInfo?.lastName
      ? `${userInfo.firstName} ${userInfo.lastName}`
      : '') ||
    '';

  const phone =
    receiverPhone ||
    receiverInfo?.receiverPhone ||
    (userInfo?.phoneData?.phone && userInfo?.phoneData?.phoneCode
      ? `+${userInfo.phoneData.phoneCode} ${userInfo.phoneData.phone}`
      : '') ||
    '';

  return [
    `Empleado: ${fullName}`,
    `ID: ${receiverIdDocument || receiverInfo?.receiverIdDocument || ''}`,
    `Código postal: ${zipCode || ''}`,
    `Número de teléfono: ${phone}`,
    `Ciudad: ${city || ''}`,
    `Indicaciones: ${additionalReferences || ''}`,
    `Dirección: ${deliveryAddress || ''}`
  ].join('\n');
};
